/** @jsx jsx */
import { Global } from '@emotion/core'
import ReactModal from 'react-modal'
import { jsx, Flex, IconButton, Box } from 'theme-ui'

import times from '../../../icons/times.svg'

import styled from '@emotion/styled'
import { useWindowSize } from '../../../hooks/useWindowSize'
import theme from '../../../gatsby-plugin-theme-ui'
import { pinBody } from '../Nav/Nav'

const Logo = styled.img`
  width: 12px;
`

const Modal = ({ children, flush, ...props }) => {
  const { smallScreen } = useWindowSize()
  const modalStyles = smallScreen ? theme.modal.fullScreen : theme.modal.small

  const responsiveStyles = smallScreen
    ? props.smallScreenStyles
    : props.desktopStyles

  return (
    <ReactModal
      isOpen={props.showModal}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      {...props}
      style={{
        width: 'auto',
        ...modalStyles,
        ...props.style,
        ...responsiveStyles,
      }}
    >
      <Global styles={pinBody} />
      {!flush ? (
        <Flex
          style={{
            justifyContent: 'space-around',
            padding: '20px',
            width: '100%',
          }}
        >
          <Box sx={{ flex: 1 }}>{props.title || ''}</Box>

          <IconButton
            style={{ p: '0', cursor: 'pointer' }}
            onClick={props.hideModal}
          >
            <Logo src={times} />
          </IconButton>
        </Flex>
      ) : (
        <IconButton
          style={{
            position: 'absolute',
            top: 10,
            right: 10,
            p: '0',
            zIndex: 30,
            cursor: 'pointer',
          }}
          onClick={props.hideModal}
        >
          <Logo src={times} />
        </IconButton>
      )}
      <Box>{children}</Box>
    </ReactModal>
  )
}

export default Modal
